import { render, staticRenderFns } from "./template-page.vue?vue&type=template&id=c70bff7c&scoped=true"
import script from "./template-page.vue?vue&type=script&lang=js"
export * from "./template-page.vue?vue&type=script&lang=js"
import style0 from "./template-page.vue?vue&type=style&index=0&id=c70bff7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70bff7c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonNewHeaderOut: require('/builds/wj/fe/wenjuan-homesite/components/common/new-header-out.vue').default,CommonDevModeWrap: require('/builds/wj/fe/wenjuan-homesite/components/common/dev-mode-wrap.vue').default})
